import api from '@/api'

const state = {

}

const mutations = {

}

const actions = {
  listSupGoods ({ commit, dispatch }, data) {
    return new Promise((resolve, reject) => {
      api.listSupGoods(data).then(res => {
        let resData = res.data
        if (resData.ret === 1 && resData.data) {
          resolve(resData)
        } else {
          if (resData.error) {
            reject({ from: '/sweb/srmSupPrice/listSupGoods', error: resData.error })
          }
        }
      }).catch(e => {
        reject({from: '/sweb/srmSupPrice/listSupGoods', error: {code: 0, msg: '网络异常，请稍后再试'}})
      })
    })
  },
  mapListCurrentPriceWithPage ({ commit, dispatch }, data) {
    return new Promise((resolve, reject) => {
      api.mapListCurrentPriceWithPage(data).then(res => {
        let resData = res.data
        if (resData.ret === 1 && resData.data) {
          resolve(resData)
        } else {
          if (resData.error) {
            reject({ from: '/sweb/srmSupPrice/mapListCurrentPriceWithPage', error: resData.error })
          }
        }
      }).catch(e => {
        reject({from: '/sweb/srmSupPrice/mapListCurrentPriceWithPage', error: {code: 0, msg: '网络异常，请稍后再试'}})
      })
    })
  },
  confirmNormalPrice ({ commit, dispatch }, data) {
    return new Promise((resolve, reject) => {
      api.confirmNormalPrice(data).then(res => {
        let resData = res.data
        if (resData.ret === 1 && resData.data) {
          resolve(resData)
        } else {
          if (resData.error) {
            reject({ from: '/sweb/srmSupPrice/confirmNormalPrice', error: resData.error })
          }
        }
      }).catch(e => {
        reject({from: '/sweb/srmSupPrice/confirmNormalPrice', error: {code: 0, msg: '网络异常，请稍后再试'}})
      })
    })
  },
  mapListSpInfo ({ commit, dispatch }, data) {
    return new Promise((resolve, reject) => {
      api.mapListSpInfo(data).then(res => {
        let resData = res.data
        if (resData.ret === 1 && resData.data) {
          resolve(resData)
        } else {
          if (resData.error) {
            reject({ from: '/sweb/srmSupPrice/mapListSpInfo', error: resData.error })
          }
        }
      }).catch(e => {
        reject({from: '/sweb/srmSupPrice/mapListSpInfo', error: {code: 0, msg: '网络异常，请稍后再试'}})
      })
    })
  },
  mapListHistoryPrice ({ commit, dispatch }, data) {
    return new Promise((resolve, reject) => {
      api.mapListHistoryPrice(data).then(res => {
        let resData = res.data
        if (resData.ret === 1 && resData.data) {
          resolve(resData)
        } else {
          if (resData.error) {
            reject({ from: '/sweb/srmSupPrice/mapListHistoryPrice', error: resData.error })
          }
        }
      }).catch(e => {
        reject({from: '/sweb/srmSupPrice/mapListHistoryPrice', error: {code: 0, msg: '网络异常，请稍后再试'}})
      })
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/price.js